<svelte:options accessors/>
<script>
    import NauiFilters from "../../naui/components/NauiFilters.svelte";
    import Chart from 'chart.js/auto';
    import {onMount} from 'svelte';

    export let filters;
    export let title;
    export let data;

    let filtersCmpt;
    let canvasBar;

    let canvasPieBodegas;
    let canvasPieMetros;

    let barData;
    let pieUnitsBodegas;
    let pieM3Bodegas;

    let barChart;
    let pieUnitsChart;
    let pieM3Chart;

    onMount(() => {
        barData = {
            labels: data.month_labels,
            datasets: [{
                label: 'm³ ocupados',
                data: [],
                backgroundColor: 'rgb(73, 88, 103)',
                borderColor: 'rgb(73, 88, 103)',
                borderWidth: 1
            }, {
                label: 'm³ disponibles',
                data: [],
                backgroundColor: 'rgb(201, 217, 207)',
                borderColor: 'rgb(201, 217, 207)',
                borderWidth: 1
            }]
        };

        pieUnitsBodegas = {
            labels: [...data.status_labels],
            datasets: [{
                label: 'Ocupación',
                data: [],
                backgroundColor: [
                    'rgb(74,88,103)',
                    'rgb(201,217,207)',
                    'rgb(69,12,12)',
                    'rgb(215,234,109)',
                    'rgb(34, 213, 23)',
                    'rgb(14, 113, 53)',
                    'rgb(114, 13, 203)',
                ],
                borderWidth: 1
            }]
        };

        pieM3Bodegas = {
            labels: [...data.status_labels],
            datasets: [{
                label: 'Ocupación',
                data: [],
                backgroundColor: [
                    'rgb(74,88,103)',
                    'rgb(201,217,207)',
                    'rgb(69,12,12)',
                    'rgb(215,234,109)',
                    'rgb(34, 213, 23)',
                    'rgb(14, 113, 53)',
                    'rgb(114, 13, 203)',
                ],
                borderWidth: 1
            }]
        };

        const configBar = {
            type: 'bar',
            data: barData,
            options: {
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            callback(value, index, ticks) {
                                return this.getLabelForValue(value) + ' m³';
                            }
                        }
                    }
                },
                plugins: {
                    legend: {
                        align: 'end'
                    }
                }
            },
        };

        const pieOptions = {
            responsive: false,
            plugins: {
                legend: {
                    position: 'right'
                }
            }
        };
        const configPieBodegas = {type: 'pie', data: pieUnitsBodegas, options: pieOptions};
        const configPieMetros = {type: 'pie', data: pieM3Bodegas, options: pieOptions};

        barChart = new Chart(canvasBar, configBar);
        pieUnitsChart = new Chart(canvasPieBodegas, configPieBodegas);
        pieM3Chart = new Chart(canvasPieMetros, configPieMetros);

        updateData();
    });

    export function updateData() {
        barData.datasets[0].data = data.occupied;
        barData.datasets[1].data = data.available;
        pieUnitsBodegas.datasets[0].data = data.units;
        pieM3Bodegas.datasets[0].data = data.m3;

        for (const [i, label] of pieUnitsBodegas.labels.entries()) {
            pieUnitsBodegas.labels[i] = `${label} - ${pieUnitsBodegas.datasets[0].data[i]} unidad/es`;
        }

        for (const [i, label] of pieM3Bodegas.labels.entries()) {
            pieM3Bodegas.labels[i] = `${label} - ${pieM3Bodegas.datasets[0].data[i]} m³`;
        }

        barChart.update();
        pieUnitsChart.update();
        pieM3Chart.update();
    }
</script>

<div class="py-15">
    {#if filters}
    <NauiFilters bind:this={filtersCmpt} {filters} on:filtered/>
    {/if}
</div>

<div class="p-15 shadow radius 2">
    <h2 class="text-l mb-1">Ocupación de por m³ - mes a mes</h2>
    <canvas bind:this={canvasBar} width="1200" height="300"></canvas>
</div>

<div class="grid-2 gap-1 py-1">
    <div class="p-15 shadow radius 2">
        <h2 class="text-l mb-1">Ocupación No. de Bodegas</h2>
        <canvas bind:this={canvasPieBodegas} width="650" height="300"></canvas>
    </div>
    <div class="p-15 shadow radius 2">
        <h2 class="text-l mb-1">Ocupación por m3</h2>
        <canvas bind:this={canvasPieMetros} width="650" height="300"></canvas>
    </div>
</div>
